<template>
    <div class="w-98 p-2">
		<!-- PIZZA das PAT -->
        <div class="p-1">
            <div class="row">
                <div class="col-4">
					<div class="janelaPequena">
						<div class="row">
							<div class="col-5">
								<div class="ml-2 tituloJanelaPequena">
									<i class="fas fa-calendar-alt mr-1"></i> Projetos ({{ qntdProjeto }})
								</div>
								<div class="ml-4">
									<Torta v-if="datasetProjeto" :styles=" {height: '90px' }" :chartdata="datasetProjeto" :options="optionsTorta" class="grafico-pequeno"></Torta>
								</div>
							</div>
							<div class="col-7">
								<div class="tituloJanelaPequena">
									<div class="mt-1 ml-4">
										<table style="line-height: 1.1;">
											<tr v-for="situacao in listaSituacaoProjeto" :key="situacao.codigo">
												<td class="text-center fonte-pequena font-weight-bold">{{situacao.quantidade}}</td><td class="font-weight-bold pl-1" :class="'titulo-'+ situacao.sigla"> {{situacao.descricao}} </td><td class="text-right pl-1"> {{situacao.porcento}}% </td>
											</tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-NI">&nbsp;Não Iniciado</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-EA">&nbsp;Em Andamento</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-AT">&nbsp;Atrasados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CA">&nbsp;Cancelados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetProjeto==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CO">&nbsp;Concluídos</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
                </div>
                <div class="col-4">
					<div class="janelaPequena">
						<div class="row">
							<div class="col-5">
								<div class="ml-2 tituloJanelaPequena">
									<i class="fas fa-calendar-alt mr-1"></i> Atividades ({{ qntdAtividade }})
								</div>
								<div class="ml-4">
									<Torta v-if="datasetAtividade" :styles=" {height: '90px' }" :chartdata="datasetAtividade" :options="optionsTorta" class="grafico-pequeno"></Torta>
								</div>
							</div>
							<div class="col-7">
								<div class="tituloJanelaPequena">
									<div class="mt-1 ml-4">
										<table style="line-height: 1.1;">
											<tr v-for="situacao in listaSituacaoAtividade" :key="situacao.codigo">
												<td class="text-center fonte-pequena font-weight-bold">{{situacao.quantidade}}</td><td class="font-weight-bold pl-1" :class="'titulo-'+ situacao.sigla"> {{situacao.descricao}} </td><td class="text-right pl-1"> {{situacao.porcento}}% </td>
											</tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-NI">&nbsp;Não Iniciado</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-EA">&nbsp;Em Andamento</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-AT">&nbsp;Atrasados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CA">&nbsp;Cancelados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetAtividade==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CO">&nbsp;Concluídos</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
                </div>
                <div class="col-4">
					<div class="janelaPequena">
						<div class="row">
							<div class="col-5">
								<div class="ml-2 tituloJanelaPequena">
									<i class="fas fa-calendar-alt mr-1"></i> Tarefas ({{ qntdTarefa }})
								</div>
								<div class="ml-4">
									<Torta v-if="datasetTarefa" :styles=" {height: '90px' }" :chartdata="datasetTarefa" :options="optionsTorta" class="grafico-pequeno"></Torta>
								</div>
							</div>
							<div class="col-7">
								<div class="tituloJanelaPequena">
									<div class="mt-1 ml-4">
										<table style="line-height: 1.1;">
											<tr v-for="situacao in listaSituacaoTarefa" :key="situacao.codigo">
												<td class="text-center fonte-pequena font-weight-bold">{{situacao.quantidade}}</td><td class="font-weight-bold pl-1" :class="'titulo-'+ situacao.sigla"> {{situacao.descricao}} </td><td class="text-right pl-1"> {{situacao.porcento}}% </td>
											</tr>
											<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-NI">&nbsp;Não Iniciado</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-EA">&nbsp;Em Andamento</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-AT">&nbsp;Atrasados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CA">&nbsp;Cancelados</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
											<tr v-if="datasetTarefa==null" class="dadoBaixoOff"><td class="text-center fonte-pequena font-weight-bold">?</td><td class="font-weight-bold titulo-CO">&nbsp;Concluídos</td><td class="text-right">&nbsp;&nbsp;?%</td></tr>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
                </div>
            </div>
        </div>

		<!-- CARROSSEL DE PROJETOS -->
		<div style="color: #8c9db3; text-align: center; height: 160px;" v-if="carregandoCarrossel">
			<div style="margin-top: 160px;">
				<span class="spinner-border spinner-border-sm mr-2" role="status">
					<span class="sr-only">Loading...</span>
				</span>Carregando Projetos...
			</div>
		</div>
		<hooper style="height: 320px;" v-if="!carregandoCarrossel && this.listaProjetoCarrossel.length > 0">
			<slide v-for="(projeto, index) in listaProjetoCarrossel" :key="projeto.nomeProjeto">
				<div class="row mt-2 bg-light">
					<div class="col-12 font-bold-500 mb-2 text-center">
						<strong>Projeto: {{ projeto.nomeProjeto }}</strong>
					</div>
					<div class="col-4">
						<div class="tituloJanelaPequena ml-4">
							Situação das atividades
						</div>
						<div>
							<Donuts v-if="datasetSituacaoProjeto[index]" :chartdata="datasetSituacaoProjeto[index]" :options="optionsDonut" class="grafico-situacao"></Donuts>
						</div>
					</div>
					<div class="col-8">
						<div>
							<div class="row">
								<div class="col-12 tituloJanelaPequena">
									Próximas atividades
								</div>
							</div>
							<table class="table table-hover mt-2">
								<tr v-for="atividade in projeto.listaAtividade" :key="atividade.idatividade">
									<td class="tdListaAtividade">
										<div class="text-wrap">
											<strong class="clickable" @click="abrirModalAtividade(atividade)">
												<i v-show="atividade.destaque" class="text-warning fas fa-star mr-1"></i>
												{{ atividade.codigoNome }}
											</strong>
										</div>
										<div style="margin-top: -20px;" :class="'font-' + atividade.situacao"
											v-if="atividade.situacao == 'CONCLUIDA' || atividade.situacao == 'CANCELADA'"><br />
											{{ atividade.situacaoDescricao }} (em {{ atividade.dataConclusao }})
										</div>
										<div style="margin-top: -20px;" class="font-atrasada" v-if="atividade.situacao == 'ATRASADA'"><br />
											{{ atividade.situacaoDescricao }} ({{atividade.atrasada }})
										</div>
										<el-tooltip :content="atividade.progresso + '%'" placement="top"
												v-if="atividade.situacao == 'EMANDAMENTO'">
											<div class="progress mt-1 w-100">
												<div class="progress-bar" role="progressbar"
													:style="'font-size: 11px; height: 3px; width: ' + atividade.progresso + '%;'"
													:class="'progresso-' + atividade.situacao">
												</div>
											</div>
										</el-tooltip>
									</td>
									<td :class="(atividade.reagendada) ? 'font-reagenda' : ''">
										<i class="far fa-calendar-alt"></i>
										{{ atividade.dataInicio }} a {{ atividade.dataFim }}
									</td>
									<td>
										<div class="row">
											<div class="col-12 text-center">
												<!--<img : src="atividade.responsavel.avatar" :title="'Responsável: '+ atividade.responsavel.nome" width="27" class="rounded-circle ml-2 mr-2"> -->
											</div>
										</div>
									</td>
								</tr>
							</table>  
						</div>
					</div>
					<div class="bg-light" style="height: 25px;">
						&nbsp;
					</div>
				</div>
			</slide>
			
			<hooper-navigation slot="hooper-addons"></hooper-navigation>
			<hooper-pagination slot="hooper-addons"></hooper-pagination>
		</hooper>

		<!-- INVESTIMENTO -->
		<div class="p-1">
            <div class="row">
                <div class="col">
					<el-tooltip content="Investimentos das Atividades Em Aberto" placement="top">
						<div class="quadroPequenoInvestimento">
							<div class="col-12 tituloQuadroPequenoInvestimento text-center">
								<i class="fas fa-dollar-sign mr-1"></i> 
								Investimento Programado
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(investimento[0] === 'R$ 888.88') ? 'dadoAltoOff' : ''">
								{{ formatarMoeda(investimento[0]) }}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Investimentos das Atividades Encerradas" placement="top">
						<div class="quadroPequenoInvestimento">
							<div class="col-12 tituloQuadroPequenoInvestimento text-center">
								<i class="fas fa-dollar-sign mr-1"></i>
								Investimento Realizado
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(investimento[1] === 'R$ 888.88') ? 'dadoAltoOff' : ''">
								{{ formatarMoeda(investimento[1]) }}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Investimentos das Atividades não programado" placement="top">
						<div class="quadroPequenoInvestimento">
							<div class="col-12 tituloQuadroPequenoInvestimento text-center">
								<i class="fas fa-dollar-sign mr-1"></i>
								Saldo Disponível
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(investimento[2] === 'R$ 888.88') ? 'dadoAltoOff' : ''">
								{{ formatarMoeda(investimento[2]) }}
							</div>
						</div>
					</el-tooltip>
                </div>
				<div class="col">
					<el-tooltip content="Investimentos das Atividades Não Empenhado" placement="top">
						<div class="quadroPequenoInvestimento">
							<div class="col-12 tituloQuadroPequenoInvestimento text-center">
								<i class="fas fa-dollar-sign mr-1"></i> 
								Investimento Não Empenhado
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(investimento[3] === 'R$ 888.88') ? 'dadoAltoOff' : ''">
								{{ formatarMoeda(investimento[3]) }}
							</div>
						</div>
					</el-tooltip>
				</div>
			</div>
		</div>

		<!-- QUADRADOS DIVERSOS -->
        <div class="p-1">
            <div class="row">
                <div class="col">
					<el-tooltip content="Projetos aguardando aprovação do coordenador" placement="top">
						<div class="quadroPequeno clickable" @click="abrirDetalhes('projeto-analise', 'Projetos em análise', 'projeto')"
								:class="(projetosPendentes[0] > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Projetos em<br/>análise
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(projetosPendentes[0] ==='!?') ? 'dadoAltoOff' : (projetosPendentes[0] > 0) ? 'fonte-pendencia' : ''">
								{{ projetosPendentes[0] }}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Projetos com pendência não validado pelo coordenador" placement="top">
						<div class="quadroPequeno clickable" @click="abrirDetalhes('projeto-devolvido', 'Projetos devolvidos', 'projeto')"
								:class="(projetosPendentes[1] > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Projetos<br/>devolvidos
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(projetosPendentes[1] ==='!?') ? 'dadoAltoOff' : (projetosPendentes[1] > 0) ? 'fonte-pendencia' : ''">
								{{ projetosPendentes[1] }}
							</div>
						</div>
					</el-tooltip>
                </div>
				<div class="col">
					<el-tooltip content="Quantidade de projetos atrasados" placement="top">
						<div class="quadroPequeno clickable" @click="abrirDetalhes('projeto-atrasado', 'Projetos atrasados', 'projeto')"
								:class="(listaSituacaoProjeto.length > 0 && listaSituacaoProjeto[2].quantidade > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Projetos<br/>atrasados
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(datasetProjeto==null) ? 'dadoAltoOff' : ''">
								{{ listaSituacaoProjeto[2].quantidade }}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Quantidade de atividades atrasadas" placement="top">
						<div class="quadroPequeno clickable" @click="abrirDetalhes('atividade-atrasada', 'Atividades atrasadas', 'atividade')"
								:class="(listaSituacaoAtividade.length > 0 && listaSituacaoAtividade[2].quantidade > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Atividades<br/>atrasadas
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(datasetAtividade==null) ? 'dadoAltoOff' : ''">
								{{ listaSituacaoAtividade[2].quantidade }}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Quantidade de tarefas atrasadas" placement="top">
						<div class="quadroPequeno clickable" @click="irAtividade()"
								:class="(listaSituacaoTarefa.length > 0 && listaSituacaoTarefa[2].quantidade > 0) ? 'bg-pendencia' : 'bg-sucesso'">
							<div class="col-12 tituloQuadroPequeno text-center">
								Tarefas<br/>atrasadas
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(datasetTarefa==null) ? 'dadoAltoOff' : ''">
								{{ listaSituacaoTarefa[2].quantidade }}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Projetos terminando nos próximos 30 dias" placement="top">
						<div class="quadroPequeno clickable" @click="abrirDetalhes('projeto-proximo', 'Projetos próximos — 30 dias', 'projeto')">
							<div class="col-12 tituloQuadroPequeno text-center">
								Projetos próximos<br/><strong>30 dias</strong>
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(patProxDias[0] ==='!?') ? 'dadoAltoOff' : ''">
								{{patProxDias[0]}}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Atividades terminando nos próximos 15 dias" placement="top">
						<div class="quadroPequeno clickable" @click="abrirDetalhes('atividade-proxima', 'Atividades próximas — 15 dias', 'atividade')">
							<div class="col-12 tituloQuadroPequeno text-center">
								Atividades próximos<br/><strong>15 dias</strong>
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(patProxDias[1] ==='!?') ? 'dadoAltoOff' : ''">
								{{patProxDias[1]}}
							</div>
						</div>
					</el-tooltip>
                </div>
                <div class="col">
					<el-tooltip content="Tarefas terminando nos próximos 10 dias" placement="top">
						<div class="quadroPequeno clickable" @click="irAtividade()">
							<div class="col-12 tituloQuadroPequeno text-center">
								Tarefas próximos<br/><strong>10 dias</strong>
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(patProxDias[2] ==='!?') ? 'dadoAltoOff' : ''">
								{{patProxDias[2]}}
							</div>
						</div>
					</el-tooltip>
                </div>
            </div>
        </div>
		<!--
        <div class="p-1">
            <div class="row">
                <div class="col">
					<el-tooltip content="Quantidadede Grupo de Trabalho a qual pertenço" placement="top">
						<div class="quadroPequeno">
							<div class="col-12 tituloQuadroPequeno text-center">
								Quantidade dos meus<br/>Grupos de Trabalho
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(qntdMeusGT[0] ==='!?') ? 'dadoAltoOff' : ''">
								{{ qntdMeusGT[0] }}
							</div>
						</div>
					</el-tooltip>
                </div>
				<div class="col">
					<el-tooltip content="Quantidadede de Coordenação a qual pertenço" placement="top">
						<div class="quadroPequeno">
							<div class="col-12 tituloQuadroPequeno text-center">
								Quantidade das minhas<br/>Coordenações
							</div>
							<div class="col-12 text-center font-weight-bold fonte-media"
								:class="(qntdMeusGT[1] ==='!?') ? 'dadoAltoOff' : ''">
								{{ qntdMeusGT[1] }}
							</div>
						</div>
					</el-tooltip>
                </div>
            </div>
        </div>		
		-->

		<!-- TABELA RELAÇÃO COLABORADORES-->
		<div class="p-1 mt-1">
            <div class="row">
                <div class="col">
					<div :class="(expandirTabela) ? '' : 'table-container'">
						<table class="table table-hover sticky-table" style="line-height: 1.1;">
							<thead>
								<tr><th rowspan="2"> <span class="ml-5">
									<el-tooltip :content="(expandirTabela) ? 'Retrair a lista dos colaboradores' : 'Expandir a lista dos colaboradores'" placement="top">
										<i @click="expandirRetrair" class="opcaoExpansao clickable"
											:class="(expandirTabela) ? 'fas fa-minus' : 'fas fa-plus'"></i>
									</el-tooltip> Colaboradores</span> </th><th colspan="9" class="text-center"> Projetos </th><th colspan="7" class="text-center" style="border-right: 1px #ccc solid"> Atividades </th></tr>
								<tr style="background-color: #f4f6f7;"><th class="text-center titulo-NI"> NI </th><th class="text-center titulo-EA"> EA </th><th class="text-center titulo-AT"> AT </th><th class="text-center"> VA </th><th class="text-center titulo-RA"> RA </th><th class="text-center titulo-CO"> CO </th><th class="text-center"> RJ </th><th class="text-center titulo-CA"> CA </th><th class="text-center"> T </th><th class="text-center titulo-NI"> NI </th><th class="text-center titulo-EA"> EA </th><th class="text-center titulo-AT"> AT </th><th class="text-center titulo-RA"> RA </th><th class="text-center titulo-CO"> CO </th><th class="text-center titulo-CA"> CA </th><th class="text-center" style="border-right: 1px #ccc solid"> T </th></tr>
							</thead>
							<tbody>
								<tr v-if="listaColaboradores.length == 0">
									<td colspan="17" class="text-center">
										<span class="spinner-border spinner-border-sm mr-2" role="status">
											<span class="sr-only">Loading...</span>
										</span>Carregando colaboradores...
									</td>
								</tr>
								<tr v-for="colab in listaColaboradores" :key="colab.usuario.idusuario">
									<td class="fonte-pequena">
										<div class="row">
											<div class="col-1">
												<img :src="colab.usuario.avatar" :title="colab.usuario.apelido" width="27" height="27" class="rounded-circle ml-2 mr-2">
											</div>
											<div class="col ml-3 mt-1">
												{{ colab.usuario.nome }}
											</div>
										</div>
									</td>	
									<td class="text-center titulo-NI">{{ (colab.pSitNI == 0) ? "-" : colab.pSitNI }}</td>
									<td class="text-center titulo-EA">{{ (colab.pSitEA == 0) ? "-" : colab.pSitEA }}</td>
									<td class="text-center titulo-AT">{{ (colab.pSitAT == 0) ? "-" : colab.pSitAT }}</td>
									<td class="text-center">{{ (colab.pSitVA == 0) ? "-" : colab.pSitVA }}</td>
									<td class="text-center titulo-RA">{{ (colab.pSitRA == 0) ? "-" : colab.pSitRA }}</td>
									<td class="text-center">{{ (colab.pSitCO == 0) ? "-" : colab.pSitCO }}</td>
									<td class="text-center titulo-CO">{{ (colab.pSitRJ == 0) ? "-" : colab.pSitRJ }}</td>
									<td class="text-center titulo-CA">{{ (colab.pSitCA == 0) ? "-" : colab.pSitCA }}</td>
									<td class="text-center fundoTotal">{{ (colab.pSitTT == 0) ? "-" : colab.pSitTT }}</td>
									<td style="border-left: 1px #ccc solid" class="text-center titulo-NI">{{ (colab.aSitNI == 0) ? "-" : colab.aSitNI }}</td>
									<td class="text-center titulo-EA">{{ (colab.aSitEA == 0) ? "-" : colab.aSitEA }}</td>
									<td class="text-center titulo-AT">{{ (colab.aSitAT == 0) ? "-" : colab.aSitAT }}</td>
									<td class="text-center titulo-RA">{{ (colab.aSitRA == 0) ? "-" : colab.aSitRA }}</td>
									<td class="text-center titulo-CO">{{ (colab.aSitCO == 0) ? "-" : colab.aSitCO }}</td>
									<td class="text-center titulo-CA">{{ (colab.aSitCA == 0) ? "-" : colab.aSitCA }}</td>
									<td style="border-right: 1px #ccc solid" class="text-center fundoTotal">{{ (colab.aSitTT == 0) ? "-" : colab.aSitTT }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-12 tituloQuadroPequeno text-right mt-1">
						<span class="titulo-NI">NI - Não Iniciado</span> &nbsp; <span class="titulo-EA">EA - Em Andamento</span> &nbsp; <span class="titulo-AT">AT - Atrasado</span> &nbsp; VA - Em Validação &nbsp; <span class="titulo-RA">RA - Reagendada</span> &nbsp; <span class="titulo-CO">CO - Concluído</span> &nbsp; RJ - Rejeitado &nbsp; <span class="titulo-CA">CA - Cancelado</span> &nbsp; <span>T - Total</span>
					</div>
				</div>
			</div>
		</div>	
		
		<modal
			:show.sync="modals.modalDetalhes"
			size="lg"
			modal-classes="modal-detalhes-inicio"
			:fechar-click="true"
		>
			<div class="text-right iconeFecharModal">
				<span @click="modals.modalDetalhes = false" class="pull-right clickable close-icon"><i class="fa fa-times"></i></span>
			</div>
			<InicioDetalhesModal :titulo="tituloDetalhes" :tipo="tipoDetalhes" :itens="listaDetalhes"
				:carregando="carregandoDetalhes" @selecionar="selecionarDetalhe" />
		</modal>

		<modal id="modalAtv" :show.sync="modals.modalAtividade" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalAtividade()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
			</div>
			<Atividade v-if="modals.modalAtividade" 
				@fechar-atividade="closeModalAtividade"
				@abrir-projeto="abrirModalProjeto"
				:atividadeSelecionada=atividadeModal />
		</modal>

		<modal id="modalProj" :show.sync="modals.modalProjeto" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalProjeto()" class="pull-right clickable close-icon"><i class="fa fa-times"></i></span>
			</div>
			<Projeto v-if="modals.modalProjeto" @fechar-projeto="closeModalProjeto"
				@abrir-atividade="abrirModalAtividade" :projetoSelecionado="projetoModal" />
		</modal>

    </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
import Torta from "./graficos/Torta.vue";
import Donuts from "./graficos/Donuts.vue";
import Atividade from "@/components/Atividade.vue";
import Projeto from "@/components/Projeto.vue";
import InicioDetalhesModal from "@/components/InicioDetalhesModal.vue";

export default {
    name: 'InicioColaborador',
	props: {
		periodo: {
			type: Object,
			required: true,
		},
	},
	components: {
		Atividade,
		Projeto,
		InicioDetalhesModal,
		Torta, Donuts,
		Hooper,
		Slide,
		HooperNavigation,
		HooperPagination
	},
	data() {
		return {
			listaSituacaoProjeto: [{quantidade: 0}, {quantidade: 0}, {quantidade: 0}, {quantidade: 0}, {quantidade: 0}],
			listaSituacaoAtividade: [{quantidade: 0}, {quantidade: 0}, {quantidade: 0}, {quantidade: 0}, {quantidade: 0}],
			listaSituacaoTarefa: [{quantidade: 0}, {quantidade: 0}, {quantidade: 0}, {quantidade: 0}, {quantidade: 0}],
			qntdProjeto: 0,
			qntdAtividade: 0,
			qntdTarefa: 0,
			listaProjetoCarrossel: [],
            datasetSituacaoProjeto: [],
            datasetProjeto: null,
            datasetAtividade: null,
            datasetTarefa: null,
            optionsDonut: {
                responsive: true,
                maintainAspectRatio: false,
				legend: {
					display: true,
				},
            },
            optionsTorta: {
                responsive: true,
                maintainAspectRatio: false,
				legend: {
					display: false,
				},
            },
			projetosPendentes: ["!?", "!?"],
			patProxDias: ["!?", "!?", "!?"],
			investimento: ["R$ 888.88", "R$ 888.88", "R$ 888.88"],
			qntdMeusGT: ["!?", "!?"],
			carregandoCarrossel: true,
			listaColaboradores: [],
			expandirTabela: false,
			modals: {
				modalProjeto: false,
				modalAtividade: false,
				modalDetalhes: false,
			},
			listaDetalhes: [],
			tituloDetalhes: "",
			tipoDetalhes: "projeto",
			carregandoDetalhes: false,
			erroFiltroNotificado: false,
			projetoModal: null,
			atividadeModal: null,
		};
	},
    created() {
        this.carregarTela();
    },
	watch: {
		periodo: {
			deep: true,
			handler() {
				this.carregarTela();
			},
		},
	},
	methods: {
		configPeriodo() {
			const params = {};
			if (this.periodo.dataInicio) params.dataInicio = this.periodo.dataInicio;
			if (this.periodo.dataFim) params.dataFim = this.periodo.dataFim;
			return {
				params,
				timeout: 60000,
				validateStatus: status => status === 200,
			};
		},
		abrirDetalhes(indicador, titulo, tipo) {
			this.erroFiltroNotificado = false;
			this.tituloDetalhes = titulo;
			this.tipoDetalhes = tipo;
			this.listaDetalhes = [];
			this.carregandoDetalhes = true;
			this.modals.modalDetalhes = true;
			this.$clubApi.get(`/inicio/colaborador/detalhe/${indicador}`, this.configPeriodo()).then((response) => {
				this.listaDetalhes = response.data.object || [];
			}).catch((error) => {
				this.notificarErroFiltro(error);
			}).finally(() => {
				this.carregandoDetalhes = false;
			});
		},
		selecionarDetalhe(item) {
			this.modals.modalDetalhes = false;
			this.$nextTick(() => {
				if (this.tipoDetalhes === "projeto") this.abrirModalProjeto(item);
				else this.abrirModalAtividade(item);
			});
		},
		async carregarTela() {
			this.erroFiltroNotificado = false;
			this.$emit("carregando", true);
			try {
				await Promise.allSettled([
					this.carregarPAT(),
					this.carregarInvestimentos(),
					this.carregarProjetosCarrossel(),
					this.carregarProjetoPendentes(),
					this.carregarPATProxDias(),
					this.carregarTabelaColaboradores(),
				]);
			} catch (error) {
				this.notificarErroFiltro(error);
			} finally {
				this.$emit("carregando", false);
			}
        },
		mensagemErro(error) {
			return error && error.response && error.response.data && error.response.data.msg
				? error.response.data.msg
				: "Não foi possível concluir o carregamento dos dados.";
		},
		notificarErroFiltro(error) {
			if (this.erroFiltroNotificado) return;
			this.erroFiltroNotificado = true;
			this.$toastr.warning(this.mensagemErro(error));
		},
		carregarPAT() {
			const projetos = this.$clubApi.get("/inicio/colaborador/projeto", this.configPeriodo()).then((response) => {
				this.listaSituacaoProjeto = response.data.object;
				this.qntdProjeto = this.listaSituacaoProjeto.reduce((accumulator, item) => { return accumulator + item.quantidade; }, 0);
				this.datasetProjeto = {
					labels: ["Não Iniciados", "Em Andamento", "Atrasados", "Cancelados", "Concluídos"],
					datasets: [{
						borderWidth: 0.5,
						backgroundColor: [
							'#ccc',
							'#65a1d1',
							'#DD1B16',
							'#E46651',
							'#28a745',
						],
						data: [this.listaSituacaoProjeto[0].quantidade, this.listaSituacaoProjeto[1].quantidade, 
							this.listaSituacaoProjeto[2].quantidade, this.listaSituacaoProjeto[3].quantidade, 
							this.listaSituacaoProjeto[4].quantidade]
					}]
				};
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
			const atividades = this.$clubApi.get("/inicio/colaborador/atividade", this.configPeriodo()).then((response) => {
				this.listaSituacaoAtividade = response.data.object;
				this.qntdAtividade = this.listaSituacaoAtividade.reduce((accumulator, item) => { return accumulator + item.quantidade; }, 0);
				this.datasetAtividade = {
					labels: ["Não Iniciadas", "Em Andamento", "Atrasadas", "Canceladas", "Concluídas"],
					datasets: [{
						borderWidth: 0.5,
						backgroundColor: [
							'#ccc',
							'#65a1d1',
							'#DD1B16',
							'#E46651',
							'#28a745',
						],
						data: [this.listaSituacaoAtividade[0].quantidade, this.listaSituacaoAtividade[1].quantidade, 
							this.listaSituacaoAtividade[2].quantidade, this.listaSituacaoAtividade[3].quantidade, 
							this.listaSituacaoAtividade[4].quantidade]
					}]
				};
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
			const tarefas = this.$clubApi.get("/inicio/colaborador/tarefa", this.configPeriodo()).then((response) => {
				this.listaSituacaoTarefa = response.data.object;
				this.qntdTarefa = this.listaSituacaoTarefa.reduce((accumulator, item) => { return accumulator + item.quantidade; }, 0);
				this.datasetTarefa = {
					labels: ["Não Iniciadas", "Em Andamento", "Atrasadas", "Canceladas", "Concluídas"],
					datasets: [{
						borderWidth: 0.5,
						backgroundColor: [
							'#ccc',
							'#65a1d1',
							'#DD1B16',
							'#E46651',
							'#28a745',
						],
						data: [this.listaSituacaoTarefa[0].quantidade, this.listaSituacaoTarefa[1].quantidade, 
							this.listaSituacaoTarefa[2].quantidade, this.listaSituacaoTarefa[3].quantidade, 
							this.listaSituacaoTarefa[4].quantidade]
					}]
            	};
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
			return Promise.allSettled([projetos, atividades, tarefas]);
		},
		carregarInvestimentos() {
			return this.$clubApi.get("/inicio/colaborador/investimento", this.configPeriodo()).then((response) => {
				this.investimento = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
        carregarProjetosCarrossel() {
			this.carregandoCarrossel = true;
			this.datasetSituacaoProjeto = [];
			return this.$clubApi.get("/inicio/colaborador/carrosel/projeto", this.configPeriodo()).then((response) => {
				this.listaProjetoCarrossel = response.data.object;
				
				let index = 0;
				this.listaProjetoCarrossel.forEach((projeto) => {

					this.datasetSituacaoProjeto[index++] = {
						labels: ["Não Iniciadas", "Em Andamento", "Atrasadas", "Canceladas", "Concluídas"],
						datasets: [{
							borderWidth: 0.5,
							backgroundColor: [
								'#ccc',
								'#65a1d1',
								'#DD1B16',
								'#E46651',
								'#28a745',
							],
							data: [projeto.listaSituacao[0].quantidade, projeto.listaSituacao[1].quantidade, 
								projeto.listaSituacao[2].quantidade, projeto.listaSituacao[3].quantidade, 
								projeto.listaSituacao[4].quantidade]
						}]
					};
				});
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			})
			.finally(() => {
				this.carregandoCarrossel = false;
			});
        },
        carregarProjetoPendentes() {
			return this.$clubApi.get("/inicio/colaborador/projeto/pendente", this.configPeriodo()).then((response) => {
				this.projetosPendentes = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
        carregarPATProxDias() {
			return this.$clubApi.get("/inicio/colaborador/pat/dias", this.configPeriodo()).then((response) => {
				this.patProxDias = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
        carregarQntdGT() {
			/*
			!retirado!
			this.$clubApi.get("/inicio/colaborador/gt").then((response) => {
				this.qntdMeusGT = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
			*/
		},
		carregarTabelaColaboradores(){
			return this.$clubApi.get("/inicio/colaborador/tabela", this.configPeriodo()).then((response) => {
				this.listaColaboradores = response.data.object;
			})
			.catch((error) => {
				this.notificarErroFiltro(error);
			});
		},
		expandirRetrair() {
			this.expandirTabela = !this.expandirTabela;
		},
        irProjeto() {
            location.href = '/projeto-listagem';
        },
        irAtividade() {
            location.href = '/atividade-listagem';
        },
		abrirModalAtividade(atividade) {
			this.atividadeModal = atividade;
			this.modals.modalAtividade = true;
		},
		closeModalAtividade() {
			this.modals.modalAtividade = false;
		},
		abrirModalProjeto(projeto) {
			this.projetoModal = projeto;
			this.modals.modalProjeto = true;
		},
		closeModalProjeto() {
			this.modals.modalProjeto = false;
		},
		formatarMoeda(value) {
			if (!value) return '';
			let numericValue = value.replace(/[^\d,.-]/g, '');
			numericValue = numericValue.replace(/\./g, '');
			numericValue = numericValue.replace(/\,/g, '');
			numericValue = numericValue.substring(0, numericValue.length-2) +"."+ numericValue.substring(numericValue.length-2, numericValue.length);
			numericValue = parseFloat(numericValue);
			return new Intl.NumberFormat('pt-BR', {
				style: 'currency',
				currency: 'BRL',
			}).format(numericValue);
		}
    },
}
</script>
<style>
.clickable {
	cursor: pointer;
}
.clickable:hover {
	cursor: pointer;
	text-decoration: none !important;
}
.tdListaAtividade {
	padding: 10px !important;
}
.w-98 {
    width: 99%;
}
.font-bold-500 {
	font-weight: 500;
}
.bg-pendencia {
    background-color: #fdeef0 !important;
    border: 1px solid #f5d4d9 !important;
}
.bg-sucesso {
    background-color: #e7f7e8 !important;
    border: 1px solid #c6f1cc !important;
}
.janelaPequena {
    border: 1px solid white;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    box-shadow: 0 0 4px rgba(0,0,0,.125),0 2px 4px rgba(0,0,0,.2);
    border-radius: 5px;
    height: 110px;
	background-color: #f0f0f0;
}
.tituloJanelaPequena {
    font-size: 11px;
}
.quadroPequeno {
    border: 1px solid #d4e5f3;
    background-color: #d0e3f3;
    border-radius: 4px;
    height: 90px;
}
.tituloQuadroPequeno {
    height: 45px;
    font-size: 11px;
}
.quadroPequenoInvestimento {
    border: 1px solid #d4e5f3;
    background-color: #d0e3f3;
    border-radius: 4px;
    height: 70px;
}
.tituloQuadroPequenoInvestimento {
    height: 25px;
    font-size: 11px;
}
.fonte-grande {
    font-size: 42px;
}
.fonte-media {
    font-size: 21px;
}
.fonte-pequena {
    font-size: 15px;
}
.font-reagenda {
	color: #b821bd !important;
	font-weight: 600;
}
.font-atrasada {
	color: red !important;
}
.font-CONCLUIDA {
	color: green !important;
}
.font-CANCELADA {
	color: red !important;
}
.fonte-pendencia {
    color: #dc3545
}
.grafico-pequeno {
    height: 300px;
}
.grafico-situacao {
    height: 240px;
}
.titulo-NI {
    color: #6d6d6d;
}
.titulo-EA {
    color: #65a1d1;
}
.titulo-CO {
    color: #28a745;
}
.titulo-AT {
	color: #DD1B16;
}
.titulo-CA {
    color: #E46651;
}
.titulo-RA {
    color: #b821bd !important;
}
.dadoBaixoOff {
    filter: blur(3px);
}
.dadoAltoOff {
    filter: blur(7px);
}

.opcaoExpansao {
	float: inline-start;
	margin-top: -40px;
	font-size: 18px;
}
.table-container {
	max-height: 275px; /* Altura máxima da tabela */
	overflow-y: auto; /* Adiciona uma barra de rolagem vertical quando necessário */
	position: relative;
}
.fundoTotal{
	background-color: #f5f5f5;
}
.sticky-table {
  width: 100%;
  border-collapse: collapse;
}
.sticky-table thead {
  /*background-color: #8d1515; /* Cor de fundo do cabeçalho */
  position: -webkit-sticky; /* Para o Safari */
  position: sticky;
  top: 0;
  z-index: 2;
}

.sticky-table th,
.sticky-table td {
  padding: 8px;
  text-align: left;
}

.sticky-table th {
  background-color: #f5f5f5; /* Cor de fundo do cabeçalho fixo */
  z-index: 1;
}

/* Estilize suas linhas de tabela conforme necessário */
.sticky-table tbody tr:hover {
  background-color: #f5f5f5; /* Cor de fundo quando a linha é destacada */
}

</style>
